import { useState } from 'react'
import {
  Plus,
  ChevronDown,
  QuestionCircle
} from 'assets/icons/components'
import {
  setRegisterModal,
  setUpgradeModal,
  setMinutePackagesModal
} from 'actions'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

import {
  AccountStatus,
  AccountStatusTitle,
  DownloadIos,
  DownloadAndroid,
  DownloadContainer,
} from '../FemaleMonetizationBox/style'

import moment from 'moment'
import { RecentCalls } from 'components//common/index'

const MalePremiumBox = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { dispatch, user } = props

  const handleTopUp = (e) => {
    e.stopPropagation()

    if (user?.account_tier === 0 && user?.gender === 0) {
      dispatch(setRegisterModal(true))
      dispatch(setUpgradeModal(false))
      return
    } else {
      if (user?.account_tier === 2) {
        dispatch(setMinutePackagesModal(true))
      } else {
        dispatch(setUpgradeModal(true))
        dispatch(setRegisterModal(false))
      }
      
      return
    }
  }

  return (
    <div className={`dashboard__premium `}>
      <div className="dashboard__premium-container">
        {/* <div className='premium__user'>
          <div
            className='user__avatar'
            style={{ backgroundImage: `url(${user?.avatar})` }}>
          </div>
          <div className='user__info'>
            <div className='info__username'>
              {user?.name}
            </div>
            <div className='info__status'>
              {user?.account_tier === 2 ?
                <div className='status__premium-status status__premium-status--premium'>
                  {t('Premium')}
                    </div>
                : user?.account_tier === 1 ?
                  <div className='status__premium-status status__premium-status--free'>
                    {t('Free')}
                      </div>
                  : <div className='status__premium-status status__premium-status--guest'>
                    {t('Guest')}
                      </div>}
              <div className='status__add-action' onClick={(e) => handleTopUp(e)}>
                <Plus className='add-action__icon' />
              </div>
              {user?.minutes_balance < 120 &&
                <div className='status__minute'>
                  {t('Minutes Low')}
                    </div>}
            </div>
          </div>
          <ChevronDown className='user__icon' />
        </div> */}
        { user?.role !== 'guest'
          ?
            <>
              {/* <div className='premium__header'>
                <div className='header__title'>
                  {t('Account Balance')}
                </div>
                {user?.account_tier === 2 &&
                  <div className='header__date'>
                    {t('Expires')}: {moment(user?.expires_at).format('MM/DD/YY hh:mm A')}
                  </div>}
              </div>
              <div className='premium__info'>
              <div className='info__wrapper'>
                <div className='wrapper__left'>
                  <div className={`left__figure`}>
                    {user?.messages_balance > 0 ? user?.messages_balance : 0}
                  </div>
                  <div className='left_title'>
                    {t('Message Left')}
                  </div>
                </div>
                <div className='wrapper__right'>
                  <OverlayTrigger
                    placement='top'
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        { t('{{messages}} message credit for every minute you spend.', { messages: '+0.5' }) } <br/>
                        { t('Video chats or send gifts.') }
                      </Tooltip>
                    }>
                    <div className='right__add-action'>
                      <QuestionCircle className='add-action__icon' />
                    </div>
                  </OverlayTrigger>
                </div> */}
                {/* <div className='wrapper__right'>
                  <div className='right__add-action' onClick={(e) => handleTopUp(e)}>
                    <Plus className='add-action__icon' />
                  </div>
                </div> */}
              {/* </div>
              <div className='info__wrapper'>
                <div className='wrapper__left'>
                  <div className={`left__figure ${user?.minutes_balance < 50 ? 'left__figure--low' : ''} `}>
                    {user?.minutes_balance > 0 ? Math.floor(user?.minutes_balance / 60) : 0}
                  </div>
                  <div className='left_title'>
                    {t('Minutes Left')}
                    </div>
                </div>
                <div className='wrapper__right'>
                  <div className='right__add-action' onClick={(e) => handleTopUp(e)}>
                    <Plus className='add-action__icon' />
                  </div>
                </div>
              </div>
            </div> */}
            </>
          : <></>
        }
      </div>
      {/* { !mobile() && <RecentCalls /> } */}
      {/* {
        user?.role !== 'guest' && !user?.is_allow_mobile_bonus
        ?
          <div className="dashboard__premium-container">
            <AccountStatus>
              <AccountStatusTitle>{t('Get the mobile app')}</AccountStatusTitle>
              <DownloadContainer>
                  <a href="https://apps.apple.com/us/app/flirtbees/id1520859706" target="_blank">
                    <DownloadIos src="/images/download-ios.png" />
                  </a>
                <a href="https://play.google.com/store/apps/details?id=com.app.flirtbees" target="_blank">
                  <DownloadAndroid src="/images/download-android.png" />
                </a>
              </DownloadContainer>
            </AccountStatus>
          </div>
        : <></>
      } */}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user
})

export default connect(mapStateToProps)(MalePremiumBox)